import { useMemo } from 'react';

const QUOTES = [
  {
    text: 'All truly great thoughts are conceived while walking.',
    author: 'Friedrich Nietzsche',
  },
  {
    text: 'I like to listen. I have learned a great deal from listening carefully. Most people never listen.',
    author: 'Ernest Hemingway',
  },
  {
    text: 'The reading of all good books is like a conversation with the finest minds of past centuries.',
    author: 'René Descartes',
  },
  {
    text: 'In every walk with nature, one receives far more than he seeks.',
    author: 'John Muir',
  },
  {
    text: 'Long before writing, people were telling each other stories.',
    author: 'Philip Pullman',
  },
  {
    text: 'The moment my legs begin to move, my thoughts begin to flow.',
    author: 'Henry David Thoreau',
  },
  {
    text: 'Curiosity is one of the permanent and certain characteristics of a vigorous mind.',
    author: 'Samuel Johnson',
  },
  {
    text: 'I have no special talent. I am only passionately curious.',
    author: 'Albert Einstein',
  },
  {
    text: 'Information is the currency of democracy.',
    author: 'Thomas Jefferson',
  },
];

export default function Greeting() {
  const quote = useMemo(() => {
    const index = Math.floor(Math.random() * QUOTES.length);
    return QUOTES[index];
  }, []);

  return (
    <p
      style={{
        fontStyle: 'italic',
        textAlign: 'center',
        color: 'var(--primary-soft)',
        margin: '0 auto 10px auto',
        maxWidth: '80dvw',
        fontSize: '0.9rem',
        lineHeight: 1.4,
      }}
    >
      "{quote.text}" — {quote.author}
    </p>
  );
}
